import { PostgrestClient } from '@supabase/postgrest-js';

// Same-origin private gateway. No Supabase cloud keys or browser-stored tokens.
const dataClient=new PostgrestClient(window.location.origin+'/rest/v1',{
  fetch:(url,options)=>fetch(url,{...options,credentials:'same-origin'}),
});
const listeners=new Set();
async function getSession(){
  const r=await fetch('/api/session',{credentials:'same-origin',cache:'no-store'});
  if(r.status===401)return {data:{session:null},error:null};
  if(!r.ok)throw new Error('Giriş servisine ulaşılamıyor.');
  return {data:{session:await r.json()},error:null};
}
async function authAction(action,values={}){
  const csrf=await fetch('/auth/csrf',{credentials:'same-origin',cache:'no-store'});
  if(!csrf.ok)throw new Error('Giriş servisine ulaşılamıyor.');
  const {csrfToken}=await csrf.json();
  const r=await fetch('/auth/'+action,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/x-www-form-urlencoded','X-Auth-Return-Redirect':'1'},body:new URLSearchParams({...values,csrfToken,callbackUrl:window.location.origin})});
  if(!r.ok)throw new Error('İşlem tamamlanamadı.');
  const result=await r.json();
  if(result.url&&new URL(result.url,window.location.origin).searchParams.has('error'))throw new Error('E-posta veya şifre geçersiz.');
}
export const supabase={
  from:table=>dataClient.from(table),rpc:(name,args)=>dataClient.rpc(name,args),
  auth:{
    getSession,
    onAuthStateChange(callback){listeners.add(callback);return {data:{subscription:{unsubscribe(){listeners.delete(callback);}}}};},
    async signInWithPassword({email,password}){try{await authAction('callback/credentials',{email,password});const {data}=await getSession();if(!data.session)throw new Error('E-posta veya şifre geçersiz.');listeners.forEach(f=>f('SIGNED_IN',data.session));return {data,error:null};}catch(error){return {data:{session:null},error};}},
    async signOut(){try{await authAction('signout');listeners.forEach(f=>f('SIGNED_OUT',null));return {error:null};}catch(error){return {error};}},
  },
};

// Retry until we find a unique code
export async function nextCustomerCode() {
  const { data } = await supabase.from('customers').select('customer_code');
  const existing = new Set((data || []).map(r => r.customer_code));
  const codes = (data || [])
    .map(r => parseInt(r.customer_code?.replace('C-', '') || '0'))
    .filter(n => !isNaN(n));
  let next = (codes.length > 0 ? Math.max(...codes) : 0) + 1;
  let code = `C-${String(next).padStart(3, '0')}`;
  while (existing.has(code)) {
    next++;
    code = `C-${String(next).padStart(3, '0')}`;
  }
  return code;
}

export async function nextProjectCode() {
  const year = new Date().getFullYear().toString().slice(2);
  const { data } = await supabase.from('projects').select('project_code');
  const existing = new Set((data || []).map(r => r.project_code));
  const codes = (data || [])
    .filter(r => r.project_code?.startsWith(`LP-${year}`))
    .map(r => parseInt(r.project_code?.slice(5) || '0'))
    .filter(n => !isNaN(n));
  let next = (codes.length > 0 ? Math.max(...codes) : 0) + 1;
  let code = `LP-${year}${String(next).padStart(3, '0')}`;
  while (existing.has(code)) {
    next++;
    code = `LP-${year}${String(next).padStart(3, '0')}`;
  }
  return code;
}
